import React from 'react';

const MirIcon: React.FC<{className?: string}> = ({ className = "w-12 h-8" }) => (
  <svg className={className} viewBox="0 0 48 32" fill="none">
    <rect width="48" height="32" rx="4" fill="white"/>
    <text x="24" y="21" textAnchor="middle" fontWeight="bold" fontSize="14" fill="#00A651" fontFamily="Arial">МИР</text>
  </svg>
);

export default MirIcon; 